export default function ($scope) {

    $scope.catalogName = $scope.catalog.root.label;
    $scope.inputCatalogName = "";
};
